import {
  jb_market_display_css_default
} from "./chunk.TK6FN5FD.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-market-display/jb-market-display.ts
var JbMarketDisplay = class extends i {
  render() {
    return b`
      <div>
        <span class="short">${this.marketShortName}</span>
        <span class="long">${this.marketName}</span>
      </div>
    `;
  }
};
JbMarketDisplay.styles = [reset_css_default, jb_market_display_css_default];
__decorateClass([
  n()
], JbMarketDisplay.prototype, "marketName", 2);
__decorateClass([
  n()
], JbMarketDisplay.prototype, "marketShortName", 2);
JbMarketDisplay = __decorateClass([
  customElement("jb-market-display")
], JbMarketDisplay);

export {
  JbMarketDisplay
};
